import { createContext, useContext, useState } from "react";

const CameraContext = createContext(null);

export const CameraProvider = ({ children }) => {
  const [cameras, setCameras] = useState([]);

  return (
    <CameraContext.Provider
      value={{
        cameras,
        setCameras,
      }}
    >
      {children}
    </CameraContext.Provider>
  );
};

export const useCamera = () => useContext(CameraContext);
